const TRUST_POINTS = [
  {
    id: 'federated',
    label: 'Federated by design',
    body: 'Your assets stay where they are and publish them wherever you choose. TikBox does not require them to sit in a central vault we control.',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="6" cy="12" r="2.5" />
        <circle cx="18" cy="6" r="2.5" />
        <circle cx="18" cy="18" r="2.5" />
        <path d="M8.2 10.9 15.8 7M8.2 13.1l7.6 3.9" />
      </svg>
    ),
  },
  {
    id: 'standards',
    label: 'Built on standards',
    body: 'C2PA/CAWG-based provenance and rights labelling, built for interoperability, and aligned with EU AI transparency requirements.',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M8.5 8.5 5 12l3.5 3.5M15.5 8.5 19 12l-3.5 3.5M13.5 5 10.5 19" />
      </svg>
    ),
  },
  {
    id: 'regulation',
    label: 'Designed for changing regulation',
    body: 'Use provenance, licensing, permissions or governance capabilities as required, then add or adjust them as your organisation and the regulatory environment change.',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 20h16M7 20V9M12 20V9M17 20V9M3 9h18L12 4 3 9Z" />
        <path d="M18.5 3.5v4M16.5 5.5h4" />
      </svg>
    ),
  },
  {
    id: 'Human-guided',
    label: 'Human-guided intelligence',
    body: 'TikBox can help interpret complex rights, policy and transparency requirements, while decisions, rules and approvals remain under your organisation’s direction.',
    // icon: (
    //   <svg viewBox="0 0 24 24" aria-hidden="true">
    //     <rect x="4" y="4" width="6" height="6" rx="1.5" />
    //     <rect x="14" y="4" width="6" height="6" rx="1.5" />
    //     <rect x="4" y="14" width="6" height="6" rx="1.5" />
    //     <path d="M17 14v6M14 17h6" />
    //   </svg>
    // ),
    
icon: (
  <svg
    viewBox="0 0 24 24"
    aria-hidden="true"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Human */}
    <circle cx="9" cy="8" r="2.5" />
    <path d="M4.5 18c.7-3 2.2-4.5 4.5-4.5s3.8 1.5 4.5 4.5" />

    {/* Spark */}
    <path d="M17.5 4v5" />
    <path d="M15 6.5h5" />
  </svg>
)

  },
]

const TrustDifferentiation = () => {
  return (
    <section className="tikbox-trust" aria-labelledby="tikbox-trust-title">
      <div className="tikbox-trust__container">
        <header className="tikbox-trust__header">
          <p className="tikbox-trust__eyebrow">Built for trust</p>
          <h2 id="tikbox-trust-title">Why organisations trust TikBox</h2>
          <p>
            Content infrastructure has to work across existing systems, open standards and changing requirements. TikBox is designed to fit that environment rather than create another closed ecosystem.
          </p>
        </header>

        <div className="tikbox-trust__grid">
          {TRUST_POINTS.map((point) => (
            <article className="tikbox-trust__proof" key={point.id}>
              <span className="tikbox-trust__icon" aria-hidden="true">
                {point.icon}
              </span>
              <div className="tikbox-trust__proof-copy">
                <h3>{point.label}</h3>
                <p>{point.body}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default TrustDifferentiation
